import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const EditContentMappingPage = withSuspense(lazy(() => import('./edit-c2')));
export default EditContentMappingPage;
